import moment from "moment";

export const isValidHex = (color) => {
    // Check if the color has the `#`, if not, prepend it
    const formattedColor = color.startsWith("#") ? color : `#${color}`;

    // Regex to check for 3 or 6 digit hex codes
    const hexRegex = /^#([0-9A-F]{3}){1,2}$/i;
    return hexRegex.test(formattedColor) ? formattedColor : null;
};


export const doesEventExistOnDate = (date, dailyRates) => {
    return dailyRates.some((event) => {
        return event.holiday && moment(event.start).isSame(date, "day");
    });
};



export const isUnavailableFunc = (rates, newRate) => {
    return rates.some(
        (existingRate) =>
            existingRate.start.getTime() === newRate.start.getTime() &&
            existingRate.unavailable
    );
};

export const isDuplicateUnvail = (items, rate) => {
    return items.some(
        (existingRate) =>
            existingRate.start.getTime() === new Date(rate?.Date).getTime() &&
            existingRate.unavailable
    );
};

export const isDuplicateFunc = (items, newRate) => {
    return items.some((existingRate) => {
        if (!existingRate?.holiday) {
            return existingRate.start.getTime() === newRate.start.getTime();
        }
    });
};

export const isMoreExpense = (items, newRate) => {
    return items.some(
        (existingRate) =>
            existingRate.start.getTime() === newRate.start.getTime() &&
            convertToPrice(existingRate.title) >= convertToPrice(newRate.title)
    );
};
export const convertToPrice = (data) => {
    if (typeof data === "string" && data.startsWith("From $")) {
        return parseInt(data.replace("From $", ""), 10) || 0;
    }
    return 0;
};
